import React from "react";
import styles from "./CategoryUpdate.module.css";
import Toggle from "../../utils/Toggle/Toggle";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { RxDragHandleHorizontal } from "react-icons/rx";

function SortableSubcategoryItem({
  sub,
  editingSubcategoryId,
  editingSubcategory,
  editSubcategoryImageInputRef,
  setEditingSubcategory,
  handleStartEditSubcategory,
  handleEditSubcategoryImageClick,
  handleEditSubcategoryImageChange,
  handleSaveEditSubcategory,
  handleCancelEditSubcategory,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: sub._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const isEditing = editingSubcategoryId === sub._id;

  return (
    <div
      ref={setNodeRef}
      style={style}
      key={sub._id || sub.name}
      className={styles.subcategoryListItem}
    >
      <div className={styles.subcategoryHeader}>
        <DragHandle listeners={listeners} attributes={attributes} />
        <span className={styles.subcategorySortId}>{sub.sortId}</span>
        <img
          src={sub.image}
          alt={sub.name}
          className={styles.subcategoryIcon}
        />
        <span className={styles.subcategoryName}>{sub.name}</span>
        {!isEditing ? (
          <button
            type="button"
            className={styles.editButton}
            onClick={() => handleStartEditSubcategory(sub)}
          >
            Edit
          </button>
        ) : null}
      </div>
      {isEditing && editingSubcategory && (
        <div className={styles.subcategoryEditForm}>
          <div className={styles.first}>
            <p>Edit Sort Id</p>
            <input
              name="editSubcategorySortId"
              placeholder="Subcategory Sort ID"
              type="number"
              onChange={(event) =>
                setEditingSubcategory((prev) => ({
                  ...prev,
                  sortId: event.target.value,
                }))
              }
              id={styles.gap}
              value={editingSubcategory.sortId}
            ></input>
          </div>
          <div className={styles.second}>
            <p>Edit Name</p>
            <input
              name="editSubcategoryName"
              placeholder="Subcategory Name"
              type="text"
              onChange={(event) =>
                setEditingSubcategory((prev) => ({
                  ...prev,
                  name: event.target.value,
                }))
              }
              id={styles.gap}
              value={editingSubcategory.name}
            ></input>
          </div>
          <div className={styles.imageurl}>
            <p>Edit Image</p>
            <div
              className={styles.imageUploadDiv}
              onClick={handleEditSubcategoryImageClick}
            >
              {editingSubcategory.image ? (
                <img
                  src={editingSubcategory.image}
                  alt="Subcategory Image"
                  className={styles.uploadedImage}
                />
              ) : (
                <div className={styles.uploadPlaceholder}>
                  <span>Click to upload image</span>
                </div>
              )}
            </div>
            <input
              ref={editSubcategoryImageInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleEditSubcategoryImageChange}
            />
          </div>
          <div className={styles.availability}>
            <p style={{ marginBottom: "16px" }}>Is Subcategory Active?</p>
            <Toggle
              status={editingSubcategory.isActive}
              setStatus={(value) =>
                setEditingSubcategory((prev) => ({
                  ...prev,
                  isActive: value,
                }))
              }
            />
          </div>
          <div className={styles.subcategoryEditActions}>
            <button
              type="button"
              className={styles.subCategoryButton}
              onClick={handleSaveEditSubcategory}
            >
              Save
            </button>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={handleCancelEditSubcategory}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function SubcategoryList({
  category,
  editingSubcategoryId,
  editingSubcategory,
  editSubcategoryImageInputRef,
  setEditingSubcategory,
  handleStartEditSubcategory,
  handleEditSubcategoryImageClick,
  handleEditSubcategoryImageChange,
  handleSaveEditSubcategory,
  handleCancelEditSubcategory,
}) {
  if (
    !category ||
    !Array.isArray(category.subCategories) ||
    category.subCategories.length === 0
  ) {
    return null;
  }

  const sortedSubcategories = [...category.subCategories].sort(
    (a, b) => a.sortId - b.sortId
  );

  return (
    <div className={styles.subcategoryList}>
      {sortedSubcategories.map((sub) => (
        <SortableSubcategoryItem
          key={sub._id}
          sub={sub}
          editingSubcategoryId={editingSubcategoryId}
          editingSubcategory={editingSubcategory}
          editSubcategoryImageInputRef={editSubcategoryImageInputRef}
          setEditingSubcategory={setEditingSubcategory}
          handleStartEditSubcategory={handleStartEditSubcategory}
          handleEditSubcategoryImageClick={handleEditSubcategoryImageClick}
          handleEditSubcategoryImageChange={handleEditSubcategoryImageChange}
          handleSaveEditSubcategory={handleSaveEditSubcategory}
          handleCancelEditSubcategory={handleCancelEditSubcategory}
        />
      ))}
    </div>
  );
}

const DragHandle = ({ listeners, attributes }) => {
  return (
    <span
      {...listeners}
      {...attributes}
      style={{
        cursor: "grab",
        padding: "8px",
        display: "inline-flex",
        alignItems: "center",
        fontSize: "18px",
        userSelect: "none",
        marginRight: "8px",
      }}
    >
      <RxDragHandleHorizontal />
    </span>
  );
};

export default SubcategoryList;
